import { IonImg, IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import './Home.scss';
import { RootState } from '../../models/RootState';
import HomeView from '../../constants/HomeView';
import Footer from '../Footer/Footer';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { connect } from 'react-redux';
import Slider from 'react-slick';

import { casinoGameSelected, setDcGameUrl } from '../../store';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';
import VirtualImg from '../../assets/images/home/sports/virtual.webp';
import SportsRadarImg from '../../assets/images/home/sports_radar.png';
import { DcGameNew } from '../../models/dc/DcGame';
import API from '../../api';
import { AxiosResponse } from 'axios';
import SVLS_API from '../../svls-api';

import GPAY from '../../assets/images/icons/GPAY.svg';
import PAYTM from '../../assets/images/icons/PAYTM.svg';
import PhonePe from '../../assets/images/icons/PhonePe.svg';
import BankTransfer from '../../assets/images/icons/BankTransfer.svg';
import UPI from '../../assets/images/icons/UPI.svg';
import { DomainConfig } from '../../models/DomainConfig';
import { BRAND_DOMAIN, BRAND_NAME } from '../../constants/Branding';
import SEO from '../SEO/Seo';
import { AuthResponse } from '../../models/api/AuthResponse';
import SportsBook from './SportsBook';
import GameCardsList from './GameCardsList';
import LiveGamesCardList from './LiveGamesCardList';
import SportsBookSlider from './SportsBookSlider';
import CasinoProvidersSlider from './CasinoProvidersSlider';
import Banner from './Banner';
import { checkForDomainConfig } from '../../util/domainConfigUtils';
import { useDomainConfigHook } from '../../hooks/domainConfigHook';

const Headings = HomeView.HOME_PAGE_HEADERS;
const Images = HomeView.HOME_PAGE_IMAGES;
const WebBanners = HomeView.HOME_PAGE_WEB_BANNERS;
const MobBanners = HomeView.HOME_PAGE_MOB_BANNERS;

const HomePageGames = HomeView.HOME_PAGE_GAMES;
const CasinoProviders = HomeView.HOME_PAGE_CASINO_TILES;

type StoreProps = {
  casinoGameSelected: (game: { id: string; name: string }) => void;
  setDcGameUrl: (url: string) => void;
  loggedIn: boolean;
  allowedConfig: number;
  domainConfig: DomainConfig;
};

const Home: React.FC<StoreProps> = (props) => {
  const { loggedIn, allowedConfig, domainConfig } = props;

  const [games, setGames] = useState<DcGameNew[]>([]);
  const [liveGames, setLiveGames] = useState<DcGameNew[]>([]);
  const [virtualGames, setVirtualGames] = useState<DcGameNew[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalTitle] = useState('Login');
  const [redirectUrl] = useState<string>('');
  const { showCasinoComponents, showSportsComponents } = useDomainConfigHook();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [providerList, setProviderList] = useState<string[]>();
  const [adminWhatsAppNumber, setAdminWhatsAppNumber] = useState<string>();
  const [apiWebBanners, setApiWebBanners] = useState([]);
  const [apiMobBanners, setApiMobBanners] = useState([]);

  const pathLocation = useLocation();

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: isMobile ? 4 : 10,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
  };

  const providerSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: isMobile ? 4 : 6,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 500,
    pauseOnHover: true,
  };

  const history = useHistory();

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const getDcGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      });
    } else {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games');
    }
    setGames(response.data);
    setProviderList(
      response.data
        .map((g) => g.subProviderName)
        .filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        })
    );
  };

  const getGameUrl = async (gameInfo: string, gameName: string) => {
    if (loggedIn) {
      const gameId = parseInt(gameInfo.split(':')[0], 10);
      const gameCode = gameInfo.split(':')[1];
      const provider = gameInfo.split(':')[2];
      const subProvider = gameInfo.split(':')[3];
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setShowDialog(true);
    }
  };

  const getAdminWhatsAppNumber = async () => {
    try {
      const response = await SVLS_API.get(
        `/account/v2/books/${BRAND_DOMAIN}`,
        {}
      );
      if (response.status === 200) {
        setAdminWhatsAppNumber(response?.data?.contact?.whatsappNumber);
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (domainConfig.whatsapp) {
      getAdminWhatsAppNumber();
    }
    fetchBannerData();
  }, [domainConfig.whatsapp]);

  const getRoyalGamingUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      if (provider === 'Indian Casino') {
        // setCasinoGame({ id: gameCode, name: gameName });
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setShowDialog(true);
    }
  };

  const navigateToLink = (data) => {
    if (
      data?.redirectionUrl == '/exchange_sports/inplay' ||
      data?.redirectionUrl == '/casino' ||
      data?.redirectionUrl == '/exchange_sports/cricket' ||
      data?.redirectionUrl == '/exchange_sports/tennis' ||
      data?.redirectionUrl == '/exchange_sports/football'
    ) {
      history.push(data?.redirectionUrl);
    } else if (data?.redirectionUrl == 'nourl') {
    } else if (data.url) {
      if (data.url.includes('/casino')) {
        if (ALLOW_CASINO) history.push(data.url);
      } else {
        history.push(data.url);
      }
    } else {
      let url = data?.redirectionUrl;
      window.open(url, '_blank');
    }
  };

  const getBanners = (device: 'mobile' | 'web') => {
    if (device === 'mobile') {
      if (apiMobBanners.length > 0) {
        return apiMobBanners;
      } else {
        return MobBanners.filter(
          (m) => (m.configPermission & allowedConfig) !== 0
        );
      }
    } else {
      if (apiWebBanners.length > 0) {
        return apiWebBanners;
      } else {
        console.log(WebBanners);
        return WebBanners.filter(
          (m) => (m.configPermission & allowedConfig) !== 0
        );
      }
    }
  };

  const fetchBannerData = async () => {
    try {
      const response: AuthResponse = await SVLS_API.get(
        `/account/v2/books/${BRAND_DOMAIN}/banners`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            status: 'active',
            type: '*',
            category: 'homebanner',
          },
        }
      );
      let data = response?.data?.banners;
      let webdata = [];
      let mobiledata = [];
      if (data?.length > 0) {
        data.map((item) => {
          if (item.deviceType === 'desktop') {
            webdata.push(item);
          } else if (item.deviceType === 'mobile') {
            mobiledata.push(item);
          }
        });
        setApiWebBanners(webdata);
        setApiMobBanners(mobiledata);
      }
    } catch (err) {
      console.log(err);
      //setShowError(true);
      if (err.response && err.response.status === 400) {
        //setErrorText(err.response.data.message);
      } else {
        //setErrorText('Something went wrong');
      }
    }
  };

  useEffect(() => {
    getDcGames();
  }, []);

  useEffect(() => {
    if (games?.length > 0) {
      setLiveGames(
        games.filter(
          (game) =>
            game?.providerName === 'RG' &&
            game?.category?.toLocaleLowerCase() !== 'virtual'
        )
      );
      setVirtualGames(
        games.filter(
          (i) =>
            i?.providerName === 'RG' &&
            i?.category?.toLocaleLowerCase() === 'virtual'
        )
      );
    }
  }, [games]);
  return (
    <>
      <SEO
        title={`${BRAND_NAME}`}
        description={'Home page description'}
        name="Home Page"
        type={'Bet on sports'}
        link={pathLocation?.pathname}
      />
      <div className="home-page">
        <div>
          <Banner
            getBanners={getBanners}
            adminWhatsAppNumber={adminWhatsAppNumber}
            navigateToLink={navigateToLink}
          />

          <IonGrid class="home-grid">
          {checkForDomainConfig(
                CONFIG_PERMISSIONS.sports,
                showSportsComponents,
                showCasinoComponents
              ) ? (
                <SportsBook />
              ) : null}

{checkForDomainConfig(
                CONFIG_PERMISSIONS.casino,
                showSportsComponents,
                showCasinoComponents
              ) ? (
              <>
                <LiveGamesCardList
                  getGameUrl={getGameUrl}
                  heading={Headings.liveGames}
                />
              </>
            ) : null}

{checkForDomainConfig(
                CONFIG_PERMISSIONS.casino,
                showSportsComponents,
                showCasinoComponents
              ) ? (
              <GameCardsList
                gameList={liveGames}
                getRoyalGamingUrl={getRoyalGamingUrl}
                heading={Headings.royalGamingLive}
              />
            ) : null}


{checkForDomainConfig(
                CONFIG_PERMISSIONS.casino,
                showSportsComponents,
                showCasinoComponents
              ) ? (
              <>
                <GameCardsList
                  gameList={virtualGames}
                  getRoyalGamingUrl={getRoyalGamingUrl}
                  heading={Headings.royalGamingVirtual}
                  redirectTo="/indian_casino"
                />
              </>
            ) : null}
{checkForDomainConfig(
                CONFIG_PERMISSIONS.sports,
                showSportsComponents,
                showCasinoComponents
              )? (
              <SportsBookSlider list={HomePageGames} />
            ) : null}

{checkForDomainConfig(
                CONFIG_PERMISSIONS.casino ,
                showSportsComponents,
                showCasinoComponents
              ) ? (
              <CasinoProvidersSlider providers={CasinoProviders} />
            ) : null}

            {domainConfig.payments ? (
              <div className="sports-grid payment-methods-ctn">
                <IonRow className="">
                  <IonCol size="12" class="sports-header">
                    <div>
                      <div className="sports-text">{Headings.payments}</div>
                    </div>
                  </IonCol>
                  <div className="payment-methods">
                    <div className="payment-method">
                      <img loading="lazy" src={GPAY} />
                    </div>
                    <div className="payment-method">
                      <img loading="lazy" src={PhonePe} />
                    </div>
                    <div className="payment-method">
                      <img loading="lazy" src={UPI} />
                    </div>
                    <div className="payment-method">
                      <img loading="lazy" src={BankTransfer} />
                    </div>
                    <div className="payment-method">
                      <img loading="lazy" src={PAYTM} />
                    </div>
                  </div>
                </IonRow>
              </div>
            ) : null}
          </IonGrid>
        </div>

        <Modal
          open={modalOpen}
          title={modalTitle}
          closeHandler={modalCloseHandler}
          size="xs"
        >
          <LoginForm
            modalCloseHandler={modalCloseHandler}
            redirectUrl={redirectUrl}
          ></LoginForm>
        </Modal>
        <Dialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Notice</DialogTitle>
          <DialogContent>
            <div className="dc-dialog-body">
              You have to be logged in to play
            </div>
          </DialogContent>
          <DialogActions className="dc-dialog-actions">
            <Button
              onClick={() => setShowDialog(false)}
              color="primary"
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Footer></Footer>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
    domainConfig: state.common.domainConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    casinoGameSelected: (game: { id: string; name: string }) =>
      dispatch(casinoGameSelected(game)),
    setDcGameUrl: (url: string) => dispatch(setDcGameUrl(url)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
